import Grid from "@mui/material/Grid2";
import FormField from "components/cck/FormField";
import { intl } from "LocaleWrapper";
import { Controller, useFormContext } from "react-hook-form";
import ShipSelect from "view/ships/components/selects/ShipSelect";
import { FormGroup } from "@cofano/cck";
import { AgreementTypeEnum } from "__generated__/enums";
import { Fragment, ReactNode } from "react";
import { AgreementFormByTypeProps } from "@schemas/agreements/schema";

type FormValues = {
	agreements: {
		ships?: {
			id: number;
			name: string;
		}[];
	}[];
}

type FormField = {
	id: string;
	render: () => ReactNode;
}

const ShipAgreementForm = ({ index, hiddenFields, contract }: AgreementFormByTypeProps) => {
	const { control, formState: { errors } } = useFormContext<FormValues>();

	const charter = contract?.charters?.[0] ?? undefined;
	const charterShips = charter?.voyages?.map(v => v.ship) ?? [];

	const isValidShipAgreement = () => {
		const validShipAgreement = contract?.agreements?.some(a =>
			(a.type === AgreementTypeEnum.Ship) &&
			(charterShips.every(ship => a.ships?.map(s => s.id).includes(ship.id))));

		return (charterShips.length === 0) || (validShipAgreement);
	};

	const ShipAgreementFormFields: FormField[] = [
		{
			id: "agreement.ships",
			render: () => (
				<Grid size={{ md: 8, xs: 12 }}>
					<FormGroup label={intl.formatMessage({ id: "SHIPS" })} overflow="hidden" required>
						<FormField
							errors={errors}
							name={`agreements.${index}.ships`}
							validation={intl.formatMessage({ id: "SHIP_AGREEMENT_WITH_SHIPS_REQUIRED_X_" }).replace("_X_", charterShips.map(s => s.name).join(", "))}>
							<Controller
								name={`agreements.${index}.ships`}
								control={control}
								rules={{
									required: true,
									validate: () => isValidShipAgreement(),
								}}
								render={({ field }) => (
									<ShipSelect
										{...field}
										multiple />
								)} />
						</FormField>
					</FormGroup>
				</Grid>
			),
		},
	];

	return <>
		{ShipAgreementFormFields
			.filter(x => !hiddenFields?.includes(x.id))
			.map(x => (
				<Fragment key={x.id}>
					{x.render()}
				</Fragment>
			))
		}
	</>;
};

export default ShipAgreementForm;
